// src/context/CheatSheetContext.js
import { useHotkeys } from '@mantine/hooks';
import { ShortcutCheatsheet } from 'constants/cheatsheet';
import { createContext, useContext, useState } from 'react';

const CheatSheetContext = createContext({});

export function CheatSheetProvider({ children }) {
  const [visible, setVisible] = useState(false);

  // Bind global hotkey mod + /
  useHotkeys([
    [
      'mod+/',
      (event) => {
        event.preventDefault();
        setVisible((v) => !v);
      },
    ],
  ]);

  return (
    <CheatSheetContext.Provider value={{ visible, setVisible }}>
      {children}
      {/* Render the overlay at the root of provider */}
      {visible && <ShortcutCheatsheet onClose={() => setVisible(false)} />}
    </CheatSheetContext.Provider>
  );
}

export function useCheatSheet() {
  const context = useContext(CheatSheetContext);
  if (!context) {
    throw new Error('useCheatSheet must be used within a CheatSheetProvider');
  }
  const { visible, setVisible } = context as {
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  };
  return {
    open: () => setVisible(true),
    close: () => setVisible(false),
    toggle: () => setVisible((v) => !v),
    visible,
  };
}
